import {
    EnhancedCheckboxRHF,
    EnhancedDropDownRHFWithLabel,
    ITest,
    LabelPosition,
    RHookFormDatePicker,
    RHookFormNumberFieldWithLabel,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useState } from "react";

// interface IBillingProfilePanel extends ITest {
//     formMethods: any;
// }

interface IBillingProfileSetupPanel extends ITest {
    formMethods: any;
}
export const BillingProfileSetupRightPanel: FC<
    IBillingProfileSetupPanel
> = ({
    formMethods,
}) => {
    const [discountSelected, setDiscountSelected] = useState(100)

    const onDiscountSelectionChangeHandler = (e:any) => {
        setDiscountSelected(e.value)
    }
    return (
        <>
        <EnhancedDropDownRHFWithLabel
				label="Invoice Generation"
				selectName="invoiceGeneration"
				testId={`invoiceGeneration`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Pay Period", value: 100 },
					{ label: "Pay Month", value: 200 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
        <EnhancedDropDownRHFWithLabel
				label="Discount"
				selectName="discountSelection"
				testId={`invoiceGeneration`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Discount Non Taxable ", value: 100 },
					{ label: "Discount Taxable", value: 200 },
				]}
				selectedItem={100}
                onSelectionChangeHandler={onDiscountSelectionChangeHandler}
			/>
            {discountSelected === 100 && <><RHookFormNumberFieldWithLabel
                label="Discount Non Taxable Percentage"
                id="discountNonTaxablePercentage"
                testId={`discount-non-taxable-percentage`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="Discount Non Taxable Amount"
                id="discountNonTaxableAmount"
                testId={`discount-non-taxable-amount`}
                labelPosition={LabelPosition.Top}
            /></>}
            {discountSelected === 200 && <><RHookFormNumberFieldWithLabel
                label="Discount Taxable Percentage"
                id="discountTaxablePercentage"
                testId={`discount-taxable-percentage`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="Discount Taxable Amount"
                id="discountTaxableAmount"
                testId={`discount-taxable-amount`}
                labelPosition={LabelPosition.Top}
            /></>}
            <RHookFormNumberFieldWithLabel
                label="NSF Penalty"
                id="nfsPenalty"
                testId={`nfs-penalty`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="TD1"
                id="td1"
                testId={`td1`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="Year End Compliance"
                id="yearEndCompliance"
                testId={`year-end-compliance`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="Inactive Period"
                id="inactivePeriod"
                testId={`inactive-period`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="Wire Transfer Charges"
                id="wireTransferCharges"
                testId={`wire-transfer-charges`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="Base Run"
                id="baseRun"
                testId={`base-run`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="Fold & Seal"
                id="foldSeal"
                testId={`fold-seal`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="Archiving"
                id="archiving"
                testId={`archiving`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="Delivery"
                id="delivery"
                testId={`delivery`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="T4 XML"
                id="t4Xml"
                testId={`t4-xml`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="Tax Forms"
                id="taxForms"
                testId={`tax-forms`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="Electronic CRA Remittance"
                id="electronicCraRemittance"
                testId={`electronic-cra-remittance`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="Time & Attendance"
                id="timeAttendance"
                testId={`time-attendance`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="Buss Pay Split Account"
                id="bussPaySplitAccount"
                testId={`buss-pay-split-account`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="ROE"
                id="roe"
                testId={`roe`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="ROE Web File By Client Per File"
                id="roeWebFileByClientPerFile"
                testId={`roe-web-file-by-client-per-file`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="ROE Web File By SU Per Emp"
                id="roeWebFileBySuPerEmp"
                testId={`roe-web-file-by-su-per-emp`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormNumberFieldWithLabel
                label="Net Suite Per Month"
                id="netSuitePerMonth"
                testId={`net-suite-per-month`}
                labelPosition={LabelPosition.Top}
            />
            
        </>
    );
};
